import { typeRootState } from 'src/store';
import { useSelector } from 'react-redux';

export const useGetIsDarkMode = () => {
    const isDarkMode = useSelector((state: typeRootState) => state.darkMode.isDarkMode);
    return isDarkMode;
}
